<div class="filters" [formGroup]="filtersForm">
    <div class="flex a-center">
        <div class="date">
            <app-common-date-picker [dateControl]="dateControl"/>
        </div>

        <div class="group mar-10">
            <app-common-dropdown [formCtrl]="groupControl"
                                 [label]="'Выбор группы'"
                                 [service]="groupsSelectorService"
                                 [noneOption]="false"
                                 data-testid="app-dropdown-group-filter"
            />
        </div>

        <mat-form-field class="mar-10">
            <mat-label>Статус заявки</mat-label>
            <mat-select formControlName="status">
                <mat-option [value]=null></mat-option>
                @for (status of enumService.enumTranslateStatusToArrSelects(StatusEnum); track status.value) {
                    <mat-option [value]="status.value">{{status.label}}</mat-option>
                }
            </mat-select>
        </mat-form-field>
        <mat-form-field class="mar-10">
            <mat-label>Адрес</mat-label>
            <input matInput formControlName="address"/>
        </mat-form-field>

        <button id="show-more-filters" mat-mini-fab (click)="showMoreFilters()" matTooltip="Дополнительные фильтры" class="mar-10">
            @if (moreFilters) {
                <mat-icon>expand_less</mat-icon>
            } @else {
                <mat-icon>expand_more</mat-icon>
            }
        </button>
    </div>
    @if (moreFilters) {
        <div class="flex">
            <mat-form-field>
                <mat-label>Номер телефона</mat-label>
                <input matInput formControlName="phone" type="number"/>
            </mat-form-field>
            <mat-form-field class="mar-10">
                <mat-label>Номер заявки</mat-label>
                <input matInput formControlName="id" type="number" min="0"/>
            </mat-form-field>
            <mat-form-field class="mar-10">
                <mat-label>ФИО клиента</mat-label>
                <input matInput formControlName="firstName"/>
            </mat-form-field>
        </div>
    }

</div>
